// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2zNot","title":"AfterBackImages_title__15XTs","images":"AfterBackImages_images__W3bSP"};